// ─── Vehicle / Car Type Endpoints ─────────────────────────────────────────────

// Car Types
export const API_GET_ALL_CAR_TYPES = '/admin/getAllCarType/';
export const API_GET_CAR_TYPES = '/admin/cartypes';
export const API_GET_CAR_TYPE_BY_ID = '/admin/cartypes/edit/';
export const API_ADD_CAR_TYPE = '/admin/addcartypes/';
export const API_EDIT_CAR_TYPE = '/admin/updatecartype/';
export const API_DELETE_CARTYPE = '/admin/removecartypes';

// Cars (Driver vehicles)
export const API_GET_ALL_DRIVER_CARS = '/admin/getcarslist/';
export const API_GET_ALL_CARS = '/admin/getAllCars/';
export const API_UPDATE_CAR_STATUS = '/admin/updateCarStatus/';
export const API_DELETE_DRIVER_CAR = '/admin/removecar/';
export const API_ADD_CAR = '/admin/addcar/';
export const API_CAR_DETAIL = '/admin/carDetail/';
export const API_EDIT_CAR = '/admin/carUpdate/';
export const API_ADMIN_UPDATE_CAR = '/admin/updateCars';
